export default __webpack_public_path__ + "static/52298-3ea9607244e74e17f9c877ffbd4d4e62.jpg";